import type { AppApi } from '@wix/wix-data-client-common'
import type { EditorSDK } from '@wix/wix-data-client-common-standalone'

export const onSchemaChange = async (
  appApi: AppApi,
  editorSdkProxy: EditorSDK,
  pagesManifestEnabled: boolean,
): Promise<void> => {
  await appApi.refreshCollectionSchemasWhenAllowed()
  if (pagesManifestEnabled) {
    editorSdkProxy.document.application.reloadManifest()
  }
}
